"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAriaMenubutton = require("react-aria-menubutton");

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../Theme");

var _Icon = require("../Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 2rem; /* Force IE to properly align flex items */\n  min-height: 2rem;\n  max-height: 3rem;\n  border: 1px solid ", ";\n  border-top-color: transparent;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  font-weight: normal;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n\n  :focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  max-height: 24rem;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  overflow-y: auto;\n  overflow-x: hidden;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: auto;\n  background-color: ", ";\n  z-index: 1000;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  user-select: none;\n  pointer-events: none;\n  display: inline-block;\n  margin-right: auto;\n  flex: 1 1 auto;\n  overflow: hidden;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  background: ", ";\n  color: ", ";\n  font-weight: normal;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  list-style-type: none;\n  cursor: pointer;\n\n  :focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  &[aria-expanded='true'] ", " {\n    display: flex;\n  }\n\n  &[aria-expanded='false'] ", " {\n    display: flex;\n  }\n\n  &[aria-disabled='true'] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  height: 1rem;\n  width: 1rem;\n  margin-right: 5px;\n  margin-left: 0.5rem;\n  pointer-events: none;\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  height: 1rem;\n  width: 1rem;\n  margin-right: 5px;\n  margin-left: 0.5rem;\n  pointer-events: none;\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 1rem;\n  width: 1rem;\n  margin-right: 5px;\n  margin-left: 0.5rem;\n  pointer-events: none;\n  display: flex;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0.25rem;\n  font-size: 0.75rem;\n  letter-spacing: 0.5px;\n\n  &[aria-disabled='true'] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 40px;\n  position: relative;\n  flex: 1 1 auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  flex-flow: column nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Root = _styledComponents.default.div(_templateObject());

var Wrapper = (0, _styledComponents.default)(_reactAriaMenubutton.Wrapper)(_templateObject2());

var Label = _styledComponents.default.span(_templateObject3());

var Icon = _styledComponents.default.span(_templateObject4());

var DownArrowIconContainer = _styledComponents.default.span(_templateObject5(), function (props) {
  return props.colorTextSecondary;
});

var UpArrowIconContainer = _styledComponents.default.span(_templateObject6(), function (props) {
  return props.colorTextSecondary;
});

var Button = (0, _styledComponents.default)(_reactAriaMenubutton.Button)(_templateObject7(), function (props) {
  return props.error ? props.theme.colorError : props.theme.colorBorder;
}, function (props) {
  return props.theme.colorBackgroundLight;
}, function (props) {
  return props.theme.colorTextPrimary;
}, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
}, UpArrowIconContainer, DownArrowIconContainer);

var Value = _styledComponents.default.span(_templateObject8());

var Menu = (0, _styledComponents.default)(_reactAriaMenubutton.Menu)(_templateObject9(), function (props) {
  return props.theme.colorBackgroundLight;
});

var MenuItems = _styledComponents.default.ul(_templateObject10());

var MenuItem = (0, _styledComponents.default)(_reactAriaMenubutton.MenuItem)(_templateObject11(), function (props) {
  return props.theme.colorBorder;
}, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorInset;
});

var DropDown = /*#__PURE__*/function (_Component) {
  _inherits(DropDown, _Component);

  function DropDown(props) {
    var _this;

    _classCallCheck(this, DropDown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropDown).call(this, props));

    var mappedItems = _this.mapItemsToObjects(props.items);

    _this.state = {
      valueId: (0, _uniqueId.default)('DropDownValue'),
      value: _this.findItemInArray(props.value, mappedItems) || {
        name: props.prompt,
        value: props.prompt
      },
      items: mappedItems
    };
    _this.onSelectNewValue = _this.onSelectNewValue.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DropDown, [{
    key: "mapItemsToObjects",
    value: function mapItemsToObjects(items) {
      if (items && items.length > 0) {
        return items.map(function (item) {
          if (typeof item.value !== 'undefined' && typeof item.name !== 'undefined') {
            return item;
          }

          return {
            value: item,
            name: item.toString()
          };
        });
      }

      return [];
    }
  }, {
    key: "findItemInArray",
    value: function findItemInArray(value, items) {
      if (value) {
        return items.find(function (item) {
          return item.value === value || item.name === value;
        });
      }

      return undefined;
    }
  }, {
    key: "onSelectNewValue",
    value: function onSelectNewValue(value, event) {
      var selectedItem = this.findItemInArray(value, this.state.items);

      if (selectedItem !== null && this.state.value !== selectedItem) {
        if (!this.props.maintainPrompt) {
          this.setState({
            value: selectedItem
          });
        }

        this.props.onSelect(value, event);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      var itemsToSearch = this.state.items;

      if (newProps.items && newProps.items !== this.state.items) {
        itemsToSearch = this.mapItemsToObjects(newProps.items);
        this.setState({
          items: itemsToSearch
        });
      }

      var newValue = this.findItemInArray(newProps.value, itemsToSearch) || {
        name: newProps.prompt,
        value: newProps.prompt
      };

      if (newValue.value !== this.state.value.value) {
        this.setState({
          value: newValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          label = _this$props.label,
          prompt = _this$props.prompt,
          disabled = _this$props.disabled,
          error = _this$props.error,
          theme = _this$props.theme;
      var _this$state = this.state,
          valueId = _this$state.valueId,
          value = _this$state.value,
          items = _this$state.items;
      return _react.default.createElement(Root, {
        className: "hw-drop-down"
      }, label && _react.default.createElement(Label, {
        className: "hw-drop-down-label",
        "aria-hidden": "true",
        role: "presentation",
        "aria-disabled": disabled
      }, label), _react.default.createElement(Wrapper, {
        onSelection: this.onSelectNewValue
      }, _react.default.createElement(Button, {
        className: "hw-drop-down-button",
        "aria-label": label || prompt,
        "aria-describedby": valueId,
        theme: theme,
        error: error,
        disabled: disabled
      }, icon && _react.default.createElement(Icon, {
        "aria-hidden": "true",
        role: "presentation"
      }, icon), _react.default.createElement(Value, {
        id: valueId,
        tabIndex: "-1" // Makes IE read aria-describedby element
        ,
        className: "hw-drop-down-value"
      }, value.name), _react.default.createElement(DownArrowIconContainer, {
        className: "hw-drop-down-icon-arrow",
        "aria-hidden": "true",
        role: "presentation",
        theme: theme
      }, _react.default.createElement(_Icon.DownArrowIcon, {
        role: "presentation"
      })), _react.default.createElement(UpArrowIconContainer, {
        className: "hw-drop-down-icon-arrow",
        "aria-hidden": "true",
        role: "presentation",
        theme: theme
      }, _react.default.createElement(_Icon.UpArrowIcon, {
        role: "presentation"
      }))), _react.default.createElement(Menu, {
        theme: theme
      }, _react.default.createElement(MenuItems, null, items.map(function (item, i) {
        return _react.default.createElement("li", {
          key: i
        }, _react.default.createElement(MenuItem, {
          value: item.value,
          text: item.name,
          theme: theme
        }, _react.default.createElement(Value, {
          className: "hw-drop-down-option"
        }, item.component || item.name)));
      })))));
    }
  }]);

  return DropDown;
}(_react.Component);

DropDown.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    component: _propTypes.default.node
  })])).isRequired,
  icon: _propTypes.default.any,
  label: _propTypes.default.string,
  error: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  prompt: _propTypes.default.string,
  maintainPrompt: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    component: _propTypes.default.node
  })]),
  onSelect: _propTypes.default.func.isRequired,
  theme: _propTypes.default.shape({
    colorTextPrimary: _propTypes.default.string,
    colorTextSecondary: _propTypes.default.string,
    colorBackgroundLight: _propTypes.default.string,
    colorBorder: _propTypes.default.string,
    focusIndicator: _propTypes.default.string,
    focusIndicatorOffset: _propTypes.default.string,
    focusIndicatorInset: _propTypes.default.string
  })
};
DropDown.defaultProps = {
  prompt: 'Select a value',
  maintainPrompt: false,
  disabled: false,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(DropDown);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/DropDown/index.js